import React from 'react'

import ModalLink from 'components/Utils/Modal/Link'
import { CHANNEL_CREATE } from 'components/Utils/Modal/constants'
import { AddIcon } from 'components/Utils/Icons'
import { Button } from 'components/base'

import { SidebarListLoading } from 'components/Layout/AppLoading'

export default React.memo(function() {
  return (
    <>
      <SidebarListLoading className="padding-horizontal-normal" />
      <ModalLink
        className="margin-top-small margin-horizontal-normal"
        to={CHANNEL_CREATE}
      >
        <Button.Primary className="font-size-large width-full flexbox-justify-start">
          <AddIcon className="margin-right-small" size={12} />
          Create a channel
        </Button.Primary>
      </ModalLink>
    </>
  )
})
